export default "__VITE_ASSET__J6i0LAzF__"